import type { SVGProps } from 'react';
import { memo } from 'react';

import { SVG_STOROKE_SIZE } from '@/data/shared/constant';

import { IconSizeType } from '@/types/icon';

interface SvgIconProps extends SVGProps<SVGSVGElement> {
  size: IconSizeType;
}
const SvgIconEllipsisVertical = ({ size = 24, ...props }: SvgIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    fill="none"
    viewBox="0 0 24 24"
    className="svgr-icon-component"
    strokeWidth={SVG_STOROKE_SIZE[size]}
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M12 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm0 6.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm.834 6.752a1.5 1.5 0 1 0-1.667 2.496 1.5 1.5 0 0 0 1.667-2.496Z"
      clipRule="evenodd"
    />
  </svg>
);
const Memo = memo(SvgIconEllipsisVertical);
export default Memo;
